import { GraphQLError } from 'graphql';

import { logErrorWithTags } from 'src/shared/telemetry/logger';

const isGraphQLAuthenticationError = (error: GraphQLError | Error) => {
  if (error instanceof GraphQLError) {
    return (
      error.message.includes('Authentication') ||
      error.message.includes('Unauthorized')
    );
  }

  return false;
};

export const useOnboardingError = () => {
  const logError = (error: GraphQLError | Error) => {
    if (!isGraphQLAuthenticationError(error)) {
      logErrorWithTags(error, { featureName: 'onboarding' });
    }
  };

  return { logError };
};
